import { useState } from "react";

export interface ModalHook {
  isShowing: boolean;
  show: () => void;
  hide: () => void;
  toggle: () => void;
}

export const useModal = (): ModalHook => {
  const [isShowing, setIsShowing] = useState(false);

  const show = () => setIsShowing(true);

  const hide = () => setIsShowing(false);

  const toggle = () => setIsShowing(!isShowing);

  return {
    isShowing,
    show,
    hide,
    toggle,
  };
};
